import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import DashboardLayout from "@/components/DashboardLayout";
import AgencyDashboard from "@/pages/AgencyDashboard";
import InfluencerDashboard from "@/pages/InfluencerDashboard";
import BrandDashboard from "@/pages/BrandDashboard";
import BrandCampaigns from "@/pages/BrandCampaigns";
import AgencyUsers from "@/pages/AgencyUsers";
import "@/App.css";

const TOAST_STYLE = {
  background: "#18181b",
  color: "#fafafa",
  border: "1px solid rgba(255,255,255,0.1)",
};
const TOAST_OPTIONS = { style: TOAST_STYLE };

function ProtectedRoute({ children, role }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="min-h-screen bg-black flex items-center justify-center text-zinc-500">
        <div className="animate-pulse font-mono text-sm">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (role && user.role !== role) {
    const target = user.role === "agency_admin" ? "/app/agency" : `/app/${user.role}`;
    return <Navigate to={target} replace />;
  }
  return <DashboardLayout>{children}</DashboardLayout>;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/app/agency" element={
        <ProtectedRoute role="agency_admin"><AgencyDashboard /></ProtectedRoute>
      } />
      <Route path="/app/agency/users" element={
        <ProtectedRoute role="agency_admin"><AgencyUsers /></ProtectedRoute>
      } />
      <Route path="/app/agency/*" element={
        <ProtectedRoute role="agency_admin"><AgencyDashboard /></ProtectedRoute>
      } />
      <Route path="/app/influencer/*" element={
        <ProtectedRoute role="influencer"><InfluencerDashboard /></ProtectedRoute>
      } />
      <Route path="/app/brand" element={
        <ProtectedRoute role="brand"><BrandDashboard /></ProtectedRoute>
      } />
      <Route path="/app/brand/campaigns" element={
        <ProtectedRoute role="brand"><BrandCampaigns /></ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster theme="dark" position="top-right" toastOptions={TOAST_OPTIONS} />
      </AuthProvider>
    </BrowserRouter>
  );
}
